module.exports = __webpack_public_path__ + "img/entity_05.fc42accf.jpg";